import React from 'react';
import { useTranslation } from 'react-i18next';
import { BottomNavigation, BottomNavigationAction, Badge, Paper } from '@mui/material';
import TableRestaurantRounded from '@mui/icons-material/TableRestaurantRounded';
import OutdoorGrillRounded from '@mui/icons-material/OutdoorGrillRounded';
import MenuBookRounded from '@mui/icons-material/MenuBookRounded';
import QueryStatsRounded from '@mui/icons-material/QueryStatsRounded';
import AdminPanelSettingsRounded from '@mui/icons-material/AdminPanelSettingsRounded';
import type { Screen } from '../../App';

interface BottomNavProps {
  screen: Screen;
  pendingCount: number;
  showAdmin: boolean;
  showTenants: boolean;
  onNavigate: (screen: Screen) => void;
}

const BottomNav: React.FC<BottomNavProps> = ({ screen, pendingCount, showAdmin, showTenants, onNavigate }) => {
  const { t } = useTranslation();

  return (
    <Paper elevation={0} sx={{ borderRadius: 0 }}>
      <BottomNavigation
        showLabels
        value={screen}
        onChange={(_event, value: Screen) => onNavigate(value)}
      >
        <BottomNavigationAction
          value="tables"
          label={t('bottomNav.tables')}
          icon={<TableRestaurantRounded />}
        />
        <BottomNavigationAction
          value="kitchen"
          label={t('bottomNav.kitchen')}
          icon={
            <Badge variant="dot" color="error" invisible={pendingCount === 0}>
              <OutdoorGrillRounded />
            </Badge>
          }
        />
        {showAdmin && (
          <BottomNavigationAction
            value="admin"
            label={t('bottomNav.admin')}
            icon={<MenuBookRounded />}
          />
        )}
        {showAdmin && (
          <BottomNavigationAction
            value="stats"
            label={t('bottomNav.stats')}
            icon={<QueryStatsRounded />}
          />
        )}
        {showTenants && (
          <BottomNavigationAction
            value="tenants"
            label={t('bottomNav.tenants')}
            icon={<AdminPanelSettingsRounded />}
          />
        )}
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNav;
